import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-center">
        Dolmen Executive Tower, Suite 706, Level 7, Sea View Road, Clifton, Karachi
      </div>
    </footer>
  );
}

export default Footer;

